module.exports = __webpack_public_path__ + "static/media/京东小哥.2eb05369.png";